module.exports = __webpack_public_path__ + "img/xian02.1f58c88f.png";